import { DataTable } from '@/components/ui/data-table/DataTable';
import { columns } from './columns';

import { useGetInvoice } from '@/service/payment/hook';
import { toastSomethingError } from '@/components/ui/toast-content';
import { useEffect } from 'react';

const InvoiceHistory = () => {
  const { data, isLoading, error } = useGetInvoice();

  useEffect(() => {
    if (error) {
      toastSomethingError(error);
    }
  }, [error]);

  return (
    <>
      <div>
        <DataTable
          data={data?.data ?? []}
          columns={columns}
          isLoading={isLoading}
        />
      </div>
    </>
  );
};

export default InvoiceHistory;
